import React from 'react';
import {
  EVBox, EVRadio, EVTypography,
} from '@eagleview/ev-comp-library';
import {
  bool, func, string,
} from 'prop-types';
import useStyles from './ReportRadio.styles';

/**
 * Report radio component with a radio button and label
 */
const ReportRadio = ({
  checked, handleRadioSelectChange, radioValue, radioLabel, disabled,
}) => {
  const styles = useStyles();

  return (
    <EVBox
      className={styles.radioContainer}
    >
      <EVRadio
        id={radioValue}
        checked={checked}
        onChange={handleRadioSelectChange}
        value={radioValue}
        color="primary"
        className={styles.radioButton}
        disabled={disabled}
      />
      <EVTypography className={styles.radioLabel}>{radioLabel}</EVTypography>
    </EVBox>
  );
};

ReportRadio.propTypes = {
  checked: bool.isRequired,
  handleRadioSelectChange: func.isRequired,
  radioValue: string.isRequired,
  radioLabel: string.isRequired,
  disabled: bool,
};

ReportRadio.defaultProps = {
  disabled: false,
};

export default ReportRadio;
